'use strict';

const Manager = require('./Manager');
const Log = require('./ManagerInsights/Log');

class ManagerInsights extends Manager {

  static CRUD = {
    ...super.CRUD,
    Log,
  };

  async getLogEntries({ id, resolution, ...rest }) {
    return this.__super__getLogEntries({
      ...rest,
      id: id,
      uri: id.split(':', 3).join(':'),
      resolution,
    });
  }

}

module.exports = ManagerInsights;
